import React, { Component } from 'react';
import { Card, Col, message, Row } from 'antd';
import Process from '@comm/workflow/Process';
import Opration from '@comm/workflow/WorkflowOp';
import Comment from '@comm/comment/Index';
import ProcessHistory from '@comm/workflow/ProcessHistory';

import {
  queryBonusDetailList,
  queryCallbackBonus,
  queryNextBonus,
  queryReturnBonus,
  querySaveBonus,
} from '@api/hr/bonus';
import FormOpen from './FormOpen';

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
      total: 0,
      pageNo: 1,
      isLoading: false,
    };
  }

  componentWillMount() {}

  componentDidMount() {
    const { data } = this.props;
    this.bonusDetailList();
    this.setState({ dataInfo: data });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataInfo: nextProps.data,
    });
  }

  /**
   * 提交报销
   */
  handSubmit = (item, type) => {
    if (type === 'save') {
      this.saveBonus(item);
    }
  };

  /**
   * 保存
   */
  saveBonus = item => {
    const context = this;
    querySaveBonus(item).then(res => {
      if (res.statusCode === 200) {
        message.success('保存成功');
        context.props.router.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 处理流程
   */
  doTask = (pass, refuse) => {
    const { dataInfo } = this.state;
    const instance = dataInfo.instance || {};
    const item = {
      instanceUuid: instance.uuid,
    };
    switch (pass) {
      case 'callback':
        this.callbackBonus(item);
        break;
      case 'next':
        this.nextBonus(item);
        break;
      case 'return':
        this.returnBonus(item, refuse);
        break;
      default:
        break;
    }
  };

  // 收回
  callbackBonus = params => {
    queryCallbackBonus(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.router.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  // 通过
  nextBonus = params => {
    this.setState({ isLoading: true });
    queryNextBonus(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.router.go(-1);
        this.setState({ isLoading: false });
      } else {
        message.error(res.message);
        this.setState({ isLoading: false });
      }
    });
  };

  // 打回
  returnBonus = (params, refuse) => {
    queryReturnBonus({
      ...params,
      ...refuse,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.router.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  handleCancel = () => {};

  /**
   * 查看流程
   */
  watchTask = () => {};

  /** ---------------------------------年终奖审核页新增 年终奖列表详情---------------------------------*/
  bonusDetailList = pageNo => {
    const params = {};
    const { data } = this.props;
    const no = this.state.pageNo;
    const current = pageNo || no;
    params.companyUuid = data.companyUuid;
    params.year = data.year;
    params.limit = 15;
    params.start = current;
    queryBonusDetailList({
      ...params,
    }).then(res => {
      this.setState({
        dataList: res.data,
        total: res.totalSize,
      });
    });
  };

  /**--------------------------------------------------------------------------------------------*/

  render() {
    const { dataInfo, dataList, total, isLoading } = this.state;
    const instance = dataInfo.instance || {};
    const histories = dataInfo.histories || [];
    const pagination = {
      showSizeChanger: false,
      pageSize: 15,
      total,
      current: this.state.pageNo,
      onChange: current => {
        this.bonusDetailList(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    return (
      <div>
        <Opration
          data={dataInfo}
          isLoading={isLoading}
          doTask={this.doTask}
          watchTask={this.watchTask}
        />
        <FormOpen
          data={dataInfo}
          dataList={dataList}
          pagination={pagination}
          handSubmit={this.handSubmit}
          doTask={this.doTask}
          watchTask={this.watchTask}
        />
        <Card title="流程跟踪">
          <Row justify="center">
            <Col span={24} style={{ marginBottom: '16px', fontSize: '14px' }}>
              <div style={{ marginBottom: '16px', fontSize: '14px' }}>流程路径：</div>
              <Process instance={instance} />
            </Col>
            <Col span={24}>
              <ProcessHistory dataSource={histories} />
            </Col>
          </Row>
        </Card>
        <Comment target={{ type: 'bonus', uuid: dataInfo.uuid }} />
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/hr/bonus/PageOpen.js